import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";

import {
  FileInputLabelRequired,
  FileImageWrapper,
  FileInput,
  DocumentRow,
  FileName,
  DeleteSpan,
  FileInputLabel,
} from "./DocumentUpload.styled";

const DocumentUploadAnotherType = (props) => {
  const {
    t,
    isEditMode,
    setFormData,
    formData,
    selectedProduct,
    existingDocuments,
    setExistingDocuments,
    title,
    addMore,
    isRequired,
  } = props;

  const onFileSelect = (e) => {
    let filesArray = formData.documentsTypeTwo;
    for (let i = 0; i < e.target.files.length; i++) {
      filesArray.push(e.target.files[i]);
    }
    setFormData({
      ...formData,
      documentsTypeTwo: filesArray,
      documentsTypeTwoError: "",
    });
  };

  const deleteFile = (index) => {
    const fileListArr = Array.from(formData.documentsTypeTwo);
    fileListArr.splice(index, 1); // here u remove the file

    // recreate file object
    let updatedDocs = [];
    const dT = new DataTransfer();
    if (fileListArr.length > 0) {
      for (let file of fileListArr) {
        dT.items.add(file);
      }
      updatedDocs = dT.files;
    }
    setFormData({
      ...formData,
      documentsTypeTwo: updatedDocs,
    });
  };
  const deleteExistingFile = (id) => {
    const documents = existingDocuments.filter((item) => item.id !== id);
    setExistingDocuments(documents);
  };

  useEffect(() => {
    if (selectedProduct && isEditMode) {
      setExistingDocuments(selectedProduct.documents);
    }
  }, [selectedProduct, isEditMode]);

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteFile(i)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          {files[i].name}
        </FileName>
      );
    }
    return docs;
  };

  const getExistingDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteExistingFile(files[i].id)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          {files[i].fileName}{" "}
        </FileName>
      );
    }
    return docs;
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        {isRequired && (
          <FileInputLabelRequired>{t(title)} </FileInputLabelRequired>
        )}
        {!isRequired && <FileInputLabel>{t(title)} </FileInputLabel>}
        {!!addMore && (
          <FileImageWrapper htmlFor="documentType">
            <Image
              src={addIcon}
              alt="upload Analytical note."
              styles={{ width: "auto" }}
            />
          </FileImageWrapper>
        )}
        <FileInput
          type="file"
          id="documentType"
          multiple
          onChange={onFileSelect}
        />
      </div>
      {isEditMode && (
        <DocumentRow>
          {existingDocuments.length > 0 &&
            getExistingDocumentList(existingDocuments)}
          {formData.documentsTypeTwo.length > 0
            ? getDocumentList(formData.documentsTypeTwo)
            : ""}
        </DocumentRow>
      )}
      {!isEditMode && formData.documentsTypeTwo.length > 0 && (
        <DocumentRow>
          {" "}
          {getDocumentList(formData.documentsTypeTwo)}{" "}
        </DocumentRow>
      )}
    </>
  );
};

DocumentUploadAnotherType.propTypes = {
  title: PropTypes.string,
  addMore: PropTypes.number,
  isRequired: PropTypes.bool,
};

DocumentUploadAnotherType.defaultProps = {
  title: "DOCUMENTS",
  addMore: true,
  isRequired: false,
};
export default withTranslation()(DocumentUploadAnotherType);
